var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoletIcone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.64 26.71",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-5{fill:none;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5{stroke:#4d69fa;}.cls-1,.cls-3,.cls-4{stroke-miterlimit:10;}.cls-1,.cls-4,.cls-5{stroke-width:0.75px;}.cls-2,.cls-5{stroke-linecap:round;stroke-linejoin:round;}.cls-4{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "volet-icone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "23.25 3.72 2.85 3.69 2.85 5.73 23.25 5.76 23.25 3.72"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.5,
    y: 5.73,
    width: 21,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.5,
    y: 7.77,
    width: 21,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.5,
    y: 0.5,
    width: 25,
    height: 3.19,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.5,
    y: 9.81,
    width: 21,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.5,
    y: 11.86,
    width: 21,
    height: 2.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.4,15.68H20.6a0,0,0,0,1,0,0v3.82a1,1,0,0,1-1,1H16.4a1,1,0,0,1-1-1V15.68A0,0,0,0,1,15.4,15.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.4,15.93H10.6a0,0,0,0,1,0,0v3.56a1,1,0,0,1-1,1H6.4a1,1,0,0,1-1-1V15.93A0,0,0,0,1,5.4,15.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13,
    y: 15.68,
    width: 10.19,
    height: 7.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.83,
    y: 15.68,
    width: 10.17,
    height: 7.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2.5,
    y: 3.69,
    width: 21,
    height: 19.49,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 20.84,
    y: 18.33,
    width: 5.43,
    height: 8,
    rx: 1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 24.55,
    y1: 21.19,
    x2: 23.55,
    y2: 20.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 22.55,
    y1: 21.19,
    x2: 23.55,
    y2: 20.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 24.55,
    y1: 23.18,
    x2: 23.55,
    y2: 24.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 22.55,
    y1: 23.18,
    x2: 23.55,
    y2: 24.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoletIcone);
export default __webpack_public_path__ + "static/media/volet-icone.8f108c23dbab9e99d406e21b2e524280.svg";
export { ForwardRef as ReactComponent };